export type RouteType = {
  HMAC_VALIDATOR: string;
};

export const ROUTES: RouteType = {
  HMAC_VALIDATOR: "/dashboard/hmac-validator",
};
